import * as coreExports from "./core";
import { AccountSyncService } from "./core/platform";
import { SessionRepository } from "./core/storage";
import { createSupabaseAccountProvider } from "./platform/supabase-account";

const sessionRepository =
  typeof window !== "undefined" && window.localStorage
    ? new SessionRepository(window.localStorage)
    : null;

const repositoryInitialization = sessionRepository?.initialize() ?? null;
const supabaseUrl =
  import.meta.env.VITE_SUPABASE_URL ?? import.meta.env.NEXT_PUBLIC_SUPABASE_URL;
const supabasePublishableKey =
  import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY ??
  import.meta.env.VITE_SUPABASE_PUBLISHABLE_DEFAULT_KEY ??
  import.meta.env.NEXT_PUBLIC_SUPABASE_PUBLISHABLE_KEY ??
  import.meta.env.NEXT_PUBLIC_SUPABASE_ANON_KEY;
const accountProvider =
  supabaseUrl && supabasePublishableKey
    ? createSupabaseAccountProvider({
        url: supabaseUrl,
        publishableKey: supabasePublishableKey,
      })
    : null;
const accountSync =
  typeof window !== "undefined" && window.localStorage
    ? new AccountSyncService(accountProvider, window.localStorage, {
        isOnline: () => window.navigator.onLine,
      })
    : null;
const core = {
  ...coreExports,
  sessionRepository,
  repositoryInitialization,
  accountSync,
  accountProviderConfigured: Boolean(accountProvider),
};

declare global {
  interface Window {
    MasterTypingCore: typeof core;
  }
}

window.MasterTypingCore = core;
document.documentElement.dataset.masterTypingCore = "ready";
window.dispatchEvent(new CustomEvent("mastertyping:core-ready"));
